/**
 *
 *  @see https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-2/tabs.html
 *
 *  This content is licensed according to the W3C Software License at
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

const tabbedPanels = () => {
  const tabList = document.querySelectorAll('[role="tablist"]')[0];
  const tabs = document.querySelectorAll('[role="tab"]');
  const panels = document.querySelectorAll('[role="tabpanel"]');

  const keys = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    enter: 13,
    space: 32,
  };

  //
  //  Add or subtract depending on key pressed
  //
  const direction = {
    37: -1,
    38: -1,
    39: 1,
    40: 1,
  };

  /**
   *
   *  Deactivate all tabs and tab panels
   *
   */
  function deactivateTabs() {
    for (let t = 0; t < tabs.length; t += 1) {
      tabs[t].setAttribute('tabindex', '-1');
      tabs[t].setAttribute('aria-selected', 'false');
    }

    for (let p = 0; p < panels.length; p += 1) {
      panels[p].setAttribute('hidden', 'hidden');
    }
  }

  /**
   *
   *  Activates any given tab panel
   *
   */
  function activateTab(tab, setFocus = true) {
    //
    //
    // TODO: FIX
    // eslint-disable-next-line no-param-reassign
    // setFocus = setFocus || true;

    //  Deactivate all other tabs
    deactivateTabs();

    const ariaControls = tab.getAttribute('aria-controls');

    tab.removeAttribute('tabindex');
    tab.setAttribute('aria-selected', 'true');
    document.getElementById(ariaControls).removeAttribute('hidden');

    //
    //  Set focus when required
    //
    if (setFocus) {
      tab.focus();
    }
  }

  /**
   *
   *  Make a guess
   *
   */
  function focusFirstTab() {
    tabs[0].focus();
  }

  /**
   *
   *  Make a guess
   *
   */
  function focusLastTab() {
    tabs[tabs.length - 1].focus();
  }

  /**
   *
   *  Focus next, previous, first or last tab depending on key pressed
   *
   */
  function switchTabOnArrowPress(event) {
    const pressed = event.keyCode;

    if (direction[pressed]) {
      const { target } = event;
      if (target.index !== undefined) {
        if (tabs[target.index + direction[pressed]]) {
          tabs[target.index + direction[pressed]].focus();
        } else if (pressed === keys.left || pressed === keys.up) {
          focusLastTab();
        } else if (pressed === keys.right || pressed === keys.down) {
          focusFirstTab();
        }
      }
    }
  }

  /**
   *
   *  When tablist’s aria-orientation is vertical, only up and down arrow should function.
   *  In all other cases only left and right arrow function.
   *
   */
  function determineOrientation(event) {
    const key = event.keyCode;
    const vertical = tabList.getAttribute('aria-orientation') === 'vertical';
    let proceed = false;

    if (vertical) {
      if (key === keys.up || key === keys.down) {
        event.preventDefault();
        proceed = true;
      }
    } else if (key === keys.left || key === keys.right) {
      proceed = true;
    }

    if (proceed) {
      switchTabOnArrowPress(event);
    }
  }

  /**
   *
   *  When a tab is clicked, activateTab is fired to activate it
   *
   */
  function clickEventListener(event) {
    const tab = event.target;
    activateTab(tab, false);
  }

  /**
   *
   *  Handles keydown on tabs
   *
   */
  function keydownEventListener(event) {
    const key = event.keyCode;

    //
    //
    // TODO: FIX
    // eslint-disable-next-line default-case
    switch (key) {
      case keys.end:
        event.preventDefault();
        // Activate last tab
        focusLastTab();
        break;
      case keys.home:
        event.preventDefault();
        // Activate first tab
        focusFirstTab();
        break;

      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case keys.up:
      case keys.down:
        determineOrientation(event);
        break;
    }
  }

  /**
   *
   *  Handles keyup on tabs
   *
   */
  function keyupEventListener(event) {
    const key = event.keyCode;

    //
    //
    // TODO: FIX
    // eslint-disable-next-line default-case
    switch (key) {
      case keys.left:
      case keys.right:
        determineOrientation(event);
        break;
      case keys.enter:
      case keys.space:
        activateTab(event.target);
        break;
    }
  }

  /**
   *
   *
   *
   */
  function addListeners(index) {
    tabs[index].addEventListener('click', clickEventListener);
    tabs[index].addEventListener('keydown', keydownEventListener);
    tabs[index].addEventListener('keyup', keyupEventListener);

    //  Build an array with all tabs (BUTTON elements) in it.
    tabs[index].index = index;
  }

  //
  //  Bind listeners
  //
  for (let i = 0; i < tabs.length; i += 1) {
    addListeners(i);
  }
};

tabbedPanels();

export default tabbedPanels;
